import React from 'react';
import styles from './CTAButton.module.scss';

const CTAButton = ({ children, onClick, variant = 'dark', size = 'large' }) => {
  return (
    <button
      className={`${styles.button} ${styles[variant]} ${styles[size]}`}
      onClick={onClick}
    >
      <span className={styles.text}>{children}</span>
      <svg
        className={styles.arrow}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M4.16669 10H15.8334M15.8334 10L10.8334 5M15.8334 10L10.8334 15"
          stroke="currentColor"
          strokeWidth="1.67"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

export default CTAButton;
